import { atom, useAtom } from "jotai";
import { useEffect } from "react";
import useNotebookBreakpoints from "utilities/hooks/domain/notebooks/use-notebook-breakpoints";

const NotebookSidebarAtom = atom<boolean | undefined>(undefined);
const useToggleNotebookSidebar = () => {
    const { isMobile } = useNotebookBreakpoints();
    const [showSidebar, setShowSidebar] = useAtom(NotebookSidebarAtom);

    useEffect(() => {
        if (showSidebar === undefined) {
            setShowSidebar(isMobile ? false : true);
        }
    }, [isMobile, setShowSidebar, showSidebar]);

    const toggleDisplay = () => {
        setShowSidebar(!showSidebar);
    };

    return {
        showSidebar,
        toggleDisplay,
    };
};

export default useToggleNotebookSidebar;
